import { DefaultCell } from '@dmc/ui/tables';
import { TranslationNamespaceBackend } from '@cas/utils/translationHelpers';
import { InvestigationStatus } from '@customer/store/apis/investigationsApi';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';

// Todo: Replace this cell renderer with a valueFormatter and getQuickFilterText callback (to enable searching by translation value).
export const InvestigationStatusRenderer = ({
  value,
  ...otherProps
}: CustomCellRendererProps<{ st: InvestigationStatus }, InvestigationStatus>): ReactElement => {
  const { t } = useTranslation();

  const text = value ? t(`Enum.InvSts.${value}`, { ns: TranslationNamespaceBackend }) : EmptyCell;

  return <DefaultCell {...otherProps} value={text} />;
};

export default InvestigationStatusRenderer;
